"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function CouponActivity(props) {
    var className = props.className, style = props.style, theme = props.theme;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var themeClass = theme ? "coupon-activity-theme-".concat(theme) : '';
    function renderTip(tip) {
        return react_1.default.createElement("div", { className: "activity-tips" }, tip);
    }
    /**
     * 代金券顶部
     */
    function renderTop() {
        var tip = props.tip, list = props.list, txt = props.txt, bgTxt = props.bgTxt;
        return (react_1.default.createElement("div", { className: "coupon-activity-top" },
            tip && renderTip(tip),
            react_1.default.createElement("ul", { className: "activity-list" }, list === null || list === void 0 ? void 0 : list.map(function (l, i) { return (react_1.default.createElement("li", { key: "ac-list-".concat(i) },
                renderCheck(),
                l)); })),
            react_1.default.createElement("span", { className: "activity-bg-txt" }, bgTxt || txt)));
    }
    /**
     * 代金券中间的凹槽
     */
    function renderSnap() {
        return (react_1.default.createElement("div", { className: "coupon-snap" },
            react_1.default.createElement("span", { className: "snap-top" }),
            react_1.default.createElement("span", { className: "snap-bottom" }),
            react_1.default.createElement("span", { className: "snap-circle" })));
    }
    /**
     * svg图片
     */
    function renderCheck() {
        return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.05386 8.56078L2.08533 9.57028L6.67967 14.4521L16.4266 4.80963L15.4079 3.76373L6.6133 11.3394L3.05386 8.56078Z", fill: "#006EFF" })));
    }
    /**
     * 代金券底部
     */
    function renderBottom() {
        var unit = props.unit, txt = props.txt, buttonText = props.buttonText;
        return (react_1.default.createElement("div", { className: "coupon-activity-bottom" },
            react_1.default.createElement("div", { className: "bottom-left" },
                react_1.default.createElement("div", { className: "activity-unit" }, unit),
                react_1.default.createElement("div", { className: "activity-txt" }, txt)),
            react_1.default.createElement("button", { className: "coupon-activity-button" }, buttonText)));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)(className, "".concat(classPrefix, "-coupon-activity"), themeClass) },
        renderTop(),
        renderSnap(),
        renderBottom()));
}
exports.default = CouponActivity;
//# sourceMappingURL=CouponActivity.js.map